// Generated from docker/_shared/legal/helperAgreementBundles.js.
// Run npm run legal:sync after changing the Docker-owned registry.

export const HELPER_APPLICATION_ACCEPTANCE_TEXT_VERSION =
  "helper-application-accept-v6";
export const HELPER_APPLICATION_ACCEPTANCE_TEXT =
  "I reviewed and agree to these agreements, including the liability waiver.";
export const PARENTAL_ACKNOWLEDGMENT_TEXT =
  "I confirm this is my parent or legal guardian's email and I may send them this authorization request.";
export const PARENT_AUTHORIZATION_ACCEPTANCE_TEXT =
  "I am at least 18 and this helper’s parent or legal guardian. I reviewed the agreements above and authorize them to use Linked Lives under those terms.";

export const parentAuthorizationDocument = Object.freeze(
  {
  "slug": "parent-guardian-authorization-agreement",
  "version": "2026-08-26",
  "sha256": "e98d09c590e4e9b13ab2509a4128035fad05fa4cb3082f5cd70e3e906cb3a86b",
  "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/parent-guardian-authorization-agreement.txt"
},
);

export const activeHelperAgreementBundle = Object.freeze({
  bundleId: "helper-application-2026-08-26-v6",
  status: "active",
  effectiveAt: "2026-08-26T00:00:00.000Z",
  documents: Object.freeze([
    Object.freeze({
      "slug": "terms-of-service",
      "version": "2026-08-26",
      "sha256": "0fe46bc9a73a84ab6a15daee8754fde2c903d15f92478621058f07431624abc4",
      "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/terms-of-service.txt"
    }),
    Object.freeze({
      "slug": "independent-contractor-agreement",
      "version": "2026-08-26",
      "sha256": "5599f00e060a11b3dfa11affd156dc66e0d67cf63f8cdcfb5196fb56b5c570fa",
      "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/independent-contractor-agreement.txt"
    }),
    Object.freeze({
      "slug": "privacy-policy",
      "version": "2026-08-26",
      "sha256": "39e9f141ef55ddf52b1f4b68bc74d4504a15298893c8249f3eceea9e7e2f57d5",
      "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/privacy-policy.txt"
    }),
    Object.freeze({
      "slug": "general-liability-waiver",
      "version": "2026-08-26",
      "sha256": "9468698f74d73542b810dbd8ec9d9b236a0bf2bc3c199bf207e43d3375fa8c26",
      "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/general-liability-waiver.txt"
    }),
  ]),
  acceptanceTexts: Object.freeze(
    {
  "helper": {
    "text": "I reviewed and agree to these agreements, including the liability waiver.",
    "version": "helper-application-accept-v6",
    "sha256": "8dd93527c100b9add440464d0f6e4837eebbacb9ef7cc37885973da347353c36"
  },
  "parental_acknowledgment": {
    "text": "I confirm this is my parent or legal guardian's email and I may send them this authorization request.",
    "version": "parental-consent-helper-ack-v6",
    "sha256": "1e473d8e5dafdca756bba12b699b9fd2d3ad8797d5dc8231b0e8b6b4f9dd4e39"
  }
},
  ),
  bundleSha256: "5c4e901cf0d19e2ed453ceeb0654d72bb8657cbf71178f8c8a3920f6ff2aba42",
});

export const activeParentAuthorizationBundle = Object.freeze(
  {
  "bundleId": "parent-authorization-2026-08-26-v3",
  "status": "active",
  "effectiveAt": "2026-08-26T00:00:00.000Z",
  "documents": [
    {
      "slug": "parent-guardian-authorization-agreement",
      "version": "2026-08-26",
      "sha256": "e98d09c590e4e9b13ab2509a4128035fad05fa4cb3082f5cd70e3e906cb3a86b",
      "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/parent-guardian-authorization-agreement.txt"
    },
    {
      "slug": "terms-of-service",
      "version": "2026-08-26",
      "sha256": "0fe46bc9a73a84ab6a15daee8754fde2c903d15f92478621058f07431624abc4",
      "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/terms-of-service.txt"
    },
    {
      "slug": "independent-contractor-agreement",
      "version": "2026-08-26",
      "sha256": "5599f00e060a11b3dfa11affd156dc66e0d67cf63f8cdcfb5196fb56b5c570fa",
      "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/independent-contractor-agreement.txt"
    },
    {
      "slug": "privacy-policy",
      "version": "2026-08-26",
      "sha256": "39e9f141ef55ddf52b1f4b68bc74d4504a15298893c8249f3eceea9e7e2f57d5",
      "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/privacy-policy.txt"
    },
    {
      "slug": "general-liability-waiver",
      "version": "2026-08-26",
      "sha256": "9468698f74d73542b810dbd8ec9d9b236a0bf2bc3c199bf207e43d3375fa8c26",
      "snapshotUrl": "/assets/legal/helper-application-2026-08-26-v6/general-liability-waiver.txt"
    }
  ],
  "acceptanceTexts": {
    "parent_authorization": {
      "text": "I am at least 18 and this helper’s parent or legal guardian. I reviewed the agreements above and authorize them to use Linked Lives under those terms.",
      "version": "parent-authorization-accept-v3",
      "sha256": "d4c5e8c2d371968fabff3cf66813970ca4558e3c00e3b869c61b24ec02aa0a79"
    }
  },
  "acceptanceTextVersion": "parent-authorization-accept-v3",
  "acceptanceTextSha256": "d4c5e8c2d371968fabff3cf66813970ca4558e3c00e3b869c61b24ec02aa0a79",
  "bundleSha256": "247e3adc927e88cbf933b7e4e52188b3d8d81890d74e8a8a2719b6b8c5bd6198"
},
);

export const isCurrentHelperAgreementAcceptance = (acceptance) =>
  Boolean(acceptance?.acceptanceId) &&
  Boolean(acceptance?.date) &&
  acceptance?.bundleId === activeHelperAgreementBundle.bundleId &&
  acceptance?.bundleSha256 === activeHelperAgreementBundle.bundleSha256 &&
  acceptance?.acceptanceTextVersion ===
    activeHelperAgreementBundle.acceptanceTexts.helper.version &&
  acceptance?.acceptanceTextSha256 ===
    activeHelperAgreementBundle.acceptanceTexts.helper.sha256;

export const isCurrentParentalAcknowledgment = (parentalConsent) =>
  parentalConsent?.status === "accepted" &&
  Boolean(parentalConsent?.acceptedAt) &&
  parentalConsent?.agreementBundleId === activeHelperAgreementBundle.bundleId &&
  parentalConsent?.agreementBundleSha256 ===
    activeHelperAgreementBundle.bundleSha256 &&
  parentalConsent?.parentAuthorizationBundleId ===
    activeParentAuthorizationBundle.bundleId &&
  parentalConsent?.parentAuthorizationBundleSha256 ===
    activeParentAuthorizationBundle.bundleSha256 &&
  parentalConsent?.parentAuthorizationAcceptanceTextVersion ===
    activeParentAuthorizationBundle.acceptanceTextVersion &&
  parentalConsent?.parentAuthorizationAcceptanceTextSha256 ===
    activeParentAuthorizationBundle.acceptanceTextSha256 &&
  Boolean(parentalConsent?.parentEmail);
